module.exports = __webpack_public_path__ + "img/upgrade.a248b67c.svg";